import Vue from 'vue'
import App from './App.vue'
import router from './routers/index'
import store from './store'
import Root from "./components/root/Root.vue";
import MorConfirm from "./components/morconfirm/Morconfirm.js";
import AuthenRoot from "./views/authen/components/root/Root.vue";
Vue.component('Root', Root);
Vue.component('AuthenRoot', AuthenRoot);

// 引入封装好的js文件的路径
import api from './js/apiconfig.js';
import J from './js/common.js';
import authenApi from './views/authen/js/apiconfig.js';
import napi from './js/notice/apiconfig.js';
// 把全局js挂接到vue原型上
Vue.prototype.Api = api;
Vue.prototype.Aapi = authenApi;
Vue.prototype.Napi = napi;
Vue.prototype.$MorConfirm= MorConfirm ;//提示弹框

router.beforeEach((to, from, next) => {


    console.log(to);
    if (to.meta.pageId == "404404") {
        if (location.href.indexOf("webapps/") >= 0) {
            // location.href = location.href.replace("8888", "9999");
        }
    }








    //记录路由历史
    let paths = J.Data.Storage("paths");
    if (!paths)
        paths = [];
    let path = to.path;
    if (paths.length == 0 || paths[0] != path) {
        paths.splice(0, 0, path);
        //超过20个删除
        if (paths.length > 20)
            paths.splice(20, 1);

        J.Data.Storage("paths", paths);
    }

    if (to.meta.pageId == "404404") {
        //404
        document.title = ""
    } else {
        /* 路由发生变化修改页面title */
        if (to.meta.title) {
            document.title = to.meta.title,
                Vue.prototype.PageId = to.meta.pageId; //pageid做菜单的选中状态和展开
        }
    }
    next()
});


new Vue({
    router,
    store,
    render: h => h(App),
    components: {}
}).$mount('#app')